/**
 * @file index.tsx
 *
 * @fileoverview Renders a Horizontal Card.
 */

import React from "react";
import FlexItems from "../../../02-atoms/06-layout/03-flex";
import Text from "../../../02-atoms/13-text/03-text";
import Spacing from "../../../02-atoms/06-layout/07-spacing";
import styles from "./horizontalCard.module.scss";
import { cva } from "class-variance-authority";

const horizontalCardMedia = cva([styles.horizontalCardMedia], {
  variants: {
    hasVideo: {
      true: styles.horizontalCardMediaHasVideo,
    },
  },
});

const horizontalCardInfo = cva([styles.horizontalCardInfo], {
  variants: {
    hasVideo: {
      true: styles.horizontalCardInfoHasVideo,
    },
  },
});

export interface HorizontalCardProps {
  /**
   * The image or video.
   */
  media?: React.ReactNode;
  /**
   * The title of the card.
   */
  title: string;
  /**
   * The content of the card.
   */
  content?: React.ReactNode;
  /**
   * The button element.
   */
  button?: React.ReactNode;
  /**
   * The flag if card contains video.
   */
  hasVideo?: boolean;
}

export const HorizontalCard = ({
  media,
  title,
  content,
  button,
  hasVideo = false,
}: HorizontalCardProps) => {
  return (
    <div className={styles.horizontalCardWrapper}>
      <FlexItems
        className={styles.horizontalCardContent}
        gap={0}
        flexDirection={["column", "row"]}
        flexWrap="nowrap"
      >
        <div className={horizontalCardMedia({ hasVideo: hasVideo })}>
          {media}
        </div>
        <div className={horizontalCardInfo({ hasVideo: hasVideo })}>
          <Text fontWeight="bold" fontSize={4} marginTop={0}>
            {title}
          </Text>
          {content && (
            <div>
              <Spacing size="large">{content}</Spacing>
            </div>
          )}
          {button && (
            <Spacing marginTop={8} marginBottom={0}>
              {button}
            </Spacing>
          )}
        </div>
      </FlexItems>
    </div>
  );
};
